import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import { useLanguage } from '../../../../Context/LanguageContext';

// Image //
import MemberShipHistoryInfoWhiteButtonImagePath from '../../../../image/MemberShipHistoryInfoWhiteButton.png';
import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';
// Image //

export default function LockerOtherUsageView(props) {
  const {
    data,
    onClickLockerModify,
    onClickLockerExtends,
    onClickLockerExit,
    onClickLockerRefund,
    onClickDeleteLockerUsageHistory
  } = props;

  const { t } = useLanguage();

  const [isClicked, setIsClicked] = useState(false);
  const [status, setStatus] = useState(t('memberDetail.statusInUse'));
  const [buttonImage, setButtonImage] = useState(MemberShipHistoryInfoButtonImagePath);
  const [fontColor, setFontColor] = useState('#595959');
  const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

  const ComponentRef = useRef(null);

  const OptionBoxRef = useRef(null);
  const OptionButtonRef = useRef(null);
  const OptionExitRef = useRef(null);
  const OptionDeleteRef = useRef(null);
  const OptionExtendRef = useRef(null);
  const OptionRefundRef = useRef(null);

  // 데이터 세팅 //
  useEffect(() => {
    if (data.status === '사용 종료') {
      setStatus(t('memberDetail.statusUsageEnded'));
      setFontColor('#FFFFFF');
      setBackgroundColor('#CACACA');
      setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
    }
    else if (data.status === '결제 예정') {
      setStatus(t('memberDetail.statusPaymentPending'));
      setFontColor('#838282');
      setBackgroundColor('#FFECBF');
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    // 시작 기한이 도래하지 않은 경우 //
    else if (moment().isBefore(moment(data.startDate))) {
      setStatus(t('memberDetail.statusPlannedUsage'));
      setFontColor('#FFFFFF');
      setBackgroundColor('#FFA800');
      setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
    }
    else {
      setStatus(t('memberDetail.statusDaysExceeded'));
      setFontColor('#FFFFFF');
      setBackgroundColor('#F48080');
      setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
    }
  }, [data])

  // 옵션버튼 클릭에 따른 UI 변경 //
  useEffect(() => {
    if (OptionBoxRef.current === null) return;

    if (isClicked) {
      if (data.status === '사용중') OptionBoxRef.current.style.height = `144px`;
      else OptionBoxRef.current.style.height = `72px`;

      OptionBoxRef.current.style.border = `1px solid #FF8B48`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #FF8B48`;
    }
  }, [isClicked, data])

  // 마우스 클릭 감지 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])
  

  // 이행 날짜 계산 후 표출 //
  function calcDate() {
    return moment(data.startDate).format('YY.MM.DD') + " - " + moment(data.endDate).format('YY.MM.DD')
  }

  // 이행 일수 계산 후 표출 //
  function calcDays() {
    return (moment(data.endDate).diff(data.startDate, 'day') + 1) + t('memberDetail.daysSuffix');
  }

  // 결제 진행된 금액 표시 //
  function calcPaymentState() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      const paymentNameMap = { '카드': t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint') };
      if (totalPrice === 0) return t('memberDetail.payFree');
      else if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }

  // 컴포넌트 마우스 호버링 //
  function onMouseOver() {
    if (!data.isExpectedLocker) OptionButtonRef.current.style.opacity = 1
  }

  // 컴포넌트 마우스 호버링 //
  function onMouseLeave() {
    if (!data.isExpectedLocker) OptionButtonRef.current.style.opacity = 0;
  }

  // 마우스로 외부 클릭시 //
  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionExitRef.current !== e.target
      && OptionExtendRef.current !== e.target
      && OptionDeleteRef.current !== e.target
      && OptionRefundRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  // 컴포넌트 클릭시 //
  function onClickComponent(e) {
    if (e.target === OptionButtonRef.current || OptionBoxRef.current.contains(e.target)) return;

    onClickLockerModify(data);
  }

  // 옵션 버튼 클릭시 //
  function onClickLockerOption() {
    if (!data.isExpectedLocker) setIsClicked(!isClicked);
  }

  // 사용연장 버튼 클릭시 //
  function onClickExtends() {
    onClickLockerExtends(data);
    setIsClicked(false);
  }

  // 사용종료 버튼 클릭시 //
  function onClickStop() {
    onClickLockerExit(data);
    setIsClicked(false);
  }

  // 락커 환불 버튼 클릭시 //
  function onClickRefund() {
    onClickLockerRefund(data);
    setIsClicked(false);
  }

  // 내역삭제 버튼 클릭시 //
  function onClickDeleteHistory() {
    onClickDeleteLockerUsageHistory(data);
    setIsClicked(false);
  }

  // 정보수정 버튼 클릭시 //
  function onClickModify() {
    onClickLockerModify(data);
    setIsClicked(false);
  }

  return (
    <TopLevelWrapper>
      <ComponentBox
        ref={ComponentRef}
        backgroundColor={backgroundColor}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClickComponent}>
        <TotalTextWrapper>
          <TextWrapper width={148}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={fontColor} cursor='pointer'>{calcDate()}</Text>
          </TextWrapper>
          <TextWrapper width={90}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={fontColor} cursor='pointer'>{calcDays()}</Text>
          </TextWrapper>
          <TextWrapper width={90}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={fontColor} cursor='pointer'>{status}</Text>
          </TextWrapper>
          <TextWrapper width={186}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={fontColor} cursor='pointer'>{calcPaymentState()}</Text>
          </TextWrapper>
          <TextWrapper width={174}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={fontColor} cursor='pointer'>{moment(data.approvalDate).format('YY.MM.DD')}</Text>
          </TextWrapper>
          <TotalIconWrapper>
            <OptionButton ref={OptionButtonRef} src={buttonImage} onClick={onClickLockerOption} />
            <OptionWrapper ref={OptionBoxRef}>
              { data.status === '사용중' && <Option ref={OptionExtendRef} onMouseDown={onClickExtends}>{t('memberDetail.extensionModal.btnExtendUsage')}</Option> }
              { data.status === '사용중' && <Option ref={OptionExitRef} onMouseDown={onClickStop}>{t('memberDetail.btnEndUsage')}</Option> }
              { data.status === '사용중' && <Option ref={OptionRefundRef} onMouseDown={onClickRefund}>{t('memberDetail.btnLockerRefund')}</Option> }
              { data.status !== '사용중' && <Option ref={OptionDeleteRef} onMouseDown={onClickDeleteHistory}>{t('memberDetail.btnDeleteHistory')}</Option> }
              <Option ref={OptionExtendRef} onMouseDown={onClickModify}>{t('memberDetail.btnModifyInfo')}</Option>
            </OptionWrapper>
          </TotalIconWrapper>
        </TotalTextWrapper>
      </ComponentBox>

    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: -35px;

  width: 816px;
  height: 87px;
  
  border-radius: 0px 0px 12px 12px;
  box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: 30px;

  margin-top: 50px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 10px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const TotalIconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 12px;
`;

const OptionButton = styled.img`
  opacity: 0;
    
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
  height: 0px;
    
  z-index: 10;

  margin-top: 40px;
  margin-left: -30px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 74px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF8B48;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #FF8B48;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;